export default "__VITE_ASSET__BOjhtV4H__"